import styled from 'styled-components';
import { vars, pxToRem, fontWeight, media } from '$util/theme';
import { getBreakpoint } from '$util/theme/breakpoints';
import { topBackgroundCss } from '$layout/partials/TopBackground';
import BannerUI from '$components/basic/Banner';
import Grid from '$components/layout/Grid';
import { Image } from '$components/basic/Image';

const { Row } = Grid;

export const SubTitle = styled.h2`
  margin-top: 20px;
  font-size: ${pxToRem(18)};
  font-weight: normal;
`;

export const HeaderImg = styled(Image)`
  position: relative;
  height: 640px;
  @media (min-width: ${getBreakpoint('xs360')}) {
    height: 590px;
  }
  ${media.up('md')} {
    height: 700px;
  }
  ${media.up('lg')} {
    height: 650px;
  }
  ${media.up('xl')} {
    height: 694px;
  }
`;

export const TopTitleWrapper = styled(Row)`
  min-width: 80%;
  .title-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${media.up('md')} {
      align-items: start;
    }
    .title {
      ${media.up('md')} {
        text-align: start !important;
        max-width: 100%;
      }
    }
    h2.subtitle {
      padding-top: 8px;
      font-size: ${pxToRem(20)} !important;
      font-weight: ${fontWeight.light};
      span {
        font-weight: ${fontWeight.bold};
      }
      ${media.up('md')} {
        padding-top: 20px;
      }
    }

    h1::first-letter,
    h2::first-letter,
    h3::first-letter,
    h4::first-letter {
      text-transform: capitalize;
    }
  }

  .img-col {
    text-align: right;
  }

  .Image {
    position: relative;
    height: 220px;
  }
`;

export const WrapperWithVideo = styled.div`
  position: relative;
`;

export default styled(Grid)`
  padding-top: 32px;
  &:not(.-withVideo) {
    ${topBackgroundCss}
  }
  &.symptom {
    background-position: bottom !important;
    ${media.down('sm')} {
      padding-bottom: 0;
    }
  }

  ${media.up('md')} {
    padding-top: 48px;
  }
  ${media.up('lg')} {
    padding-top: 54px;
  }

  &.locationPage .AdvantagesDiv {
    margin-bottom: 0;
  }

  &.-withVideo {
    position: absolute;
    z-index: 10;
    top: 0;
    width: 100%;
    height: 640px;
    @media (min-width: ${getBreakpoint('xs360')}) {
      height: 590px;
    }
    ${media.up('md')} {
      height: 700px;
    }
    ${media.up('lg')} {
      padding-top: 0;
      padding-bottom: 0;
      height: 650px;
    }
    ${media.up('xl')} {
      height: 694px;
    }
    > .container {
      height: 100%;
    }
    .content-wrapper {
      justify-content: space-evenly;
      ${media.only('md')} {
        justify-content: space-around;
        margin-bottom: 36px;
      }
      ${media.up('lg')} {
        align-items: start !important;
        justify-content: center;
      }
      .react-autosuggest__suggestions-container--open {
        height: 230px !important;
        ${media.up('lg')} {
          height: 300px !important;
        }
      }
    }
    h1,
    h2 {
      a {
        text-decoration: underline;
      }
    }
    h1,
    h2,
    h2 > .link-1,
    h2 a {
      color: ${vars.quantumverse.reskinColors.white};
      text-align: center !important;
      width: 100%;
      ${media.up('lg')} {
        text-align: left !important;
      }
    }
    h1 {
      font-size: ${pxToRem(32)} !important;
      line-height: ${pxToRem(37)};
      ${media.up('md')} {
        margin-bottom: 10px !important;
      }
      ${media.up('lg')} {
        margin-bottom: 20px !important;
      }
      ${media.up('xl')} {
        font-size: ${pxToRem(48)} !important;
        line-height: ${pxToRem(55)};
        margin-bottom: 15px !important;
      }
      ${media.down('lg')} {
        br {
          display: none;
        }
      }
    }
    h2,
    h2 > .link-1,
    h2 a {
      font-size: ${pxToRem(20)} !important;
      font-weight: 500;
      line-height: ${pxToRem(28)};
      margin-top: 0;
      margin-bottom: 0;
      ${media.up('lg')} {
        margin-bottom: 25px !important;
      }
      ${media.up('xl')} {
        font-weight: ${fontWeight.semiLight};
        font-size: ${pxToRem(25)} !important;
        line-height: ${pxToRem(39)};
      }
      > span {
        font-weight: ${fontWeight.semiBold};
      }
    }
    h2 > .link-1,
    h2 a {
      &:hover {
        color: ${vars.quantumverse.reskinColors.purple500};
      }
    }
    .VrmLookupWithVideo {
      height: 100%;
      ${media.up('lg')} {
        display: flex;
        flex-flow: row-reverse;
        h1 {
          max-width: 538px;
        }
      }
      img.-job {
        display: none;
      }
      .VrmLookupCard {
        margin-top: 0 !important;
        padding: 0;
        max-width: 520px;
        ${media.up('lg')} {
          padding: 26px;
          color: ${vars.quantumverse.reskinColors.neutral700};
          margin-left: 0;
        }
        .VrmLookup {
          .input-group {
            display: block;
            .postcode,
            .vrm {
              width: 100%;
              padding-right: 0 !important;
              label {
                ${media.down('md')} {
                  color: ${vars.quantumverse.reskinColors.purple500};
                }
              }
            }
            .postcode {
              margin-bottom: 15px;
            }
          }
        }
        .call-us {
          .call-us-icon {
            ${media.down('md')} {
              display: none !important;
            }
          }
          > span,
          > span > a {
            color: ${vars.quantumverse.reskinColors.white};
            ${media.up('lg')} {
              color: ${vars.quantumverse.reskinColors.neutral300};
            }
          }
          > span > a:hover {
            color: ${vars.quantumverse.reskinColors.purple500};
          }
        }
      }
    }
    .Bottom {
      margin-top: 40px;
      ${media.up('md')} {
        margin-top: 60px;
      }
      &.mot {
        margin-top: 0;
      }
      > .part-of-renault {
        margin-top: 0;
      }
    }
    .video-wrapper {
      justify-content: center;
      .-play {
        cursor: pointer;
        opacity: 0.8;
        transition: opacity 1s ease-in-out;
        &:hover {
          opacity: 1;
        }
      }
    }
    .ReassuranceSection {
      padding-top: 0;
      width: 100%;
    }
  }

  &.referralPage {
    padding-top: 32px;
    ${media.up('md')} {
      padding-top: 60px;
    }
    .top-wrapper.referral {
      margin: -16px;
      padding: 0 16px;
      text-align: left;
      position: relative;

      h3 {
        font-size: ${pxToRem(38)};
        line-height: 1.05;
        ${media.up('xl')} {
          font-size: ${pxToRem(58)};
          line-height: 1.12;
        }
        > span > span {
          font-weight: ${fontWeight.regular};
        }
      }
      h2 {
        font-size: ${pxToRem(17)};
        line-height: 1.35;
        ${media.up('xl')} {
          padding-top: 40px;
          font-size: ${pxToRem(24)};
          line-height: 1.17;
        }
      }

      h2,
      h3 {
        color: ${vars.quantumverse.reskinColors.white};
      }

      .vrm-lookup,
      h2,
      h3 {
        position: relative;
        z-index: 1;
      }

      .vrm-lookup {
        margin: 50px 0 30px;
        padding: 0;
        background: ${vars.transparent};
        .input-helper {
          color: ${vars.quantumverse.reskinColors.white};
        }
      }
    }
  }

  .top-wrapper {
    .title {
      ${media.down('lg')} {
        font-size: ${pxToRem(32)};
      }
      .break {
        ${media.up('md')} {
          display: block;
        }
      }
      .light {
        font-weight: ${fontWeight.light};
      }
    }
    .VrmLookupCard {
      margin: 20px auto 0px;
      ${media.up('lg')} {
        margin: 34px auto 0px;
      }
      .item-error {
        color: ${vars.red};
      }
      .anticon-check-circle {
        display: none;
      }
    }
    .ImgCar {
      img {
        height: auto;
        width: 350px !important;
        max-width: 100%;
        max-height: 100%;
        ${media.up('lg')} {
          width: 450px !important;
        }
      }
    }

    .ImgCarLogo {
      img {
        height: 90px !important;
        margin-bottom: 20px !important;
      }
    }
    > .Col {
      > .vrm-lookup {
        width: inherit;
      }
    }
    &.main {
      > .Col {
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
          margin-bottom: 10px;
          text-align: center;
          ${media.up('md')} {
            margin-bottom: 0;
            text-align: left;
          }
        }
      }
    }

    &.carMakes-top,
    &.workOperations-top {
      > .Col {
        text-align: center;
      }
      h1.title {
        font-size: ${pxToRem(28)};
        ${media.up('md')} {
          margin-bottom: 30px;
          font-size: ${pxToRem(36)};
        }
        ${media.up('lg')} {
          font-size: ${pxToRem(50)};
        }
      }
    }

    &.symptom-top {
      > .Col {
        text-align: center;
      }
      h1.title {
        font-size: ${pxToRem(28)};
        ${media.up('md')} {
          margin-bottom: 30px;
          font-size: ${pxToRem(36)};
        }
        ${media.up('lg')} {
          font-size: ${pxToRem(46)};
          max-width: 710px;
          margin: auto;
          line-height: 55px;
        }
      }
      h2 {
        font-size: 24px;
        font-weight: 300;
      }
      img {
        margin-bottom: 20px;
      }
    }

    &.symptomsIndex-top {
      text-align: center;
      h1 {
        max-width: 1100px;
        margin: auto;
        margin-bottom: 25px;
        .symptomsIndex-title {
          max-width: 1100px;
          font-weight: 350;
          display: block;
          margin: auto;
          ${media.up('md')} {
            margin-bottom: 30px;
            font-size: ${pxToRem(36)};
          }
          ${media.up('lg')} {
            font-size: ${pxToRem(48)};
          }
        }
      }
      .subtitle {
        max-width: 720px;
        display: block;
        margin: auto;
        font-size: ${pxToRem(20)};
        font-weight: ${fontWeight.light};
        ${media.up('md')} {
          font-size: ${pxToRem(24)};
        }
      }
    }

    &.partner-top {
      .Col {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        > h3 {
          font-size: ${pxToRem(32)};
          font-weight: ${fontWeight.semiBold};
          ${media.up('md')} {
            font-size: ${pxToRem(48)};
          }
        }
        > h2 {
          font-size: ${pxToRem(19)};
          font-weight: ${fontWeight.light};
          .sm-none {
            display: none;
          }
          ${media.up('md')} {
            font-size: ${pxToRem(24)};
            .sm-none {
              display: block;
            }
          }
        }
        > h2,
        > h3 {
          text-align: center;
        }
      }
    }

    &.car {
      &.desktop {
        > .left-col {
          > .top-title {
            text-align: left;
            margin-bottom: 30px;

            .Image {
              max-width: 70px;
              padding-bottom: 15px;
            }
          }
        }
        > .right-col {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          ${media.up('lg')} {
            justify-content: flex-end;
          }
          > .Image {
            padding-bottom: 80px;
          }
        }
      }
      &.mobile {
        flex-direction: column;
        align-items: center;
        > .car-images {
          display: flex;
          justify-content: center;
          align-items: center;

          .title-image {
            height: auto;
            width: 120px;
            padding-right: 20px;
          }
          > .Image {
            width: 120px;
          }
        }
        .title {
          font-size: ${pxToRem(32)};
          text-align: center;
          margin: 10px 0;
          > span {
            font-weight: ${fontWeight.semiBold};
          }
        }
        .part-of-renault {
          display: flex;
          justify-content: center;
          > .PartOfRenault {
            margin-top: 30px;
          }
        }
      }
    }

    .carMakes-sub,
    .workOperations-sub {
      font-size: ${pxToRem(20)};
      font-weight: ${fontWeight.light};
      ${media.up('md')} {
        font-size: ${pxToRem(24)};
      }
    }

    .workOperations-title {
      ${media.down('md')} {
        margin-bottom: 24px;
      }
    }

    .carMakes-title {
      font-weight: ${fontWeight.light};
      > strong {
        font-weight: ${fontWeight.bold};
      }
    }

    .vrm-lookup {
      margin: 20px auto 0 auto;
      ${media.up('lg')} {
        margin: 34px auto 0 auto;
      }
    }

    .postcode {
      text-align: left;
      .react-autosuggest__input {
        ${media.up('lg')} {
          min-width: 140px;
        }
      }
    }

    img.Trustpilot {
      margin: 20px auto;
      width: 500px;
      ${media.up('md')} {
        margin: 20px auto 30px;
      }
    }
  }

  .middle-wrapper {
    @media (max-width: ${getBreakpoint('md')}) {
      display: none;
      padding: 15px;
    }

    display: flex;
    justify-content: center;

    > div {
      margin: 0 34px 0 0;
      display: flex;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }

  .Bottom {
    display: flex;
    justify-content: center;
    align-items: center;

    ${media.down('sm')} {
      overflow: hidden;
    }

    .part-of-renault {
      margin-top: 60px;
      display: flex;
      justify-content: center;
      &.with-path {
        margin-top: 0;
      }
    }
    .cars {
      display: flex;
      justify-content: center;
    }
    .cars {
      margin-top: 32px;
      display: flex;
      justify-content: center;
    }

    > .AdvantagesDiv {
      ${media.down('sm')} {
        margin-top: 20px;
        margin-bottom: 0;
        .ant-col > .card-2 {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .car-search,
  .workOperations-search {
    margin-top: 20px;
    ${media.down('sm')} {
      background: transparent !important;
      box-shadow: none !important;
      padding: 0;
    }
    ${media.up('md')} {
      width: 610px;
      margin: 20px auto 0;
    }
    .react-autosuggest__container {
      margin-top: 10px;
    }
    .react-autosuggest__suggestions-container {
      position: absolute;
      width: 530px;
      ${media.down('sm')} {
        width: calc(100% - 40px);
      }
      z-index: 2;
    }
  }
`;

export const BackgroundImg = styled.div`
  background-image: url('https://res.cloudinary.com/fxtr/image/upload/v1623769396/landing/referral/keys-dropoff-1x-optimized_ostotk.jpg');
  background-size: cover;
  position: absolute;
  width: 133vw;
  height: 100%;
  left: -33vw;
  top: 0;
`;

export const Gradient = styled.div`
  background: rgba(0, 0, 0, 0.1);
  background: linear-gradient(142deg, rgba(0, 0, 0, 0.7) 32%, transparent 100%);
  height: 100%;
  width: 133vw;
  position: absolute;
  top: 0;
  left: -33vw;
  z-index: 0;
`;

export const Banner = styled(BannerUI)`
  background: ${vars.quantumverse.reskinColors.red100} !important;
  color: ${vars.quantumverse.reskinColors.red400} !important;

  .qvIcon {
    margin-right: 10px;
  }

  .discount {
    margin-right: 5px;
    ${media.up('md')} {
      margin-right: 10px;
    }
  }
  .code {
    font-weight: ${fontWeight.bold};
    padding-left: 5px;
  }
  .PartnerImg {
    margin-left: 10px;
    padding: 10px 0;
    height: 100%;
    max-height: 60px;
    &.dynamic {
      padding-left: 4px;
      margin-top: -2px;
      > span {
        height: inherit !important;
        width: inherit !important;
      }
    }
    &.esure {
      width: 100px;
    }
    &.caranalytics {
      width: 130px;
      padding-bottom: 10px;
    }
    &.sheilas-wheels {
      width: 200px;
    }
    &.turo {
      width: 70px;
    }
    &.justpark {
      width: 110px;
      padding-left: 0;
    }
    &.perkbox {
      width: 130px;
    }
    &.getaround {
      width: 150px;
      padding-left: 0;
      margin-bottom: -5px;
    }
    &.kapten {
      width: 140px;
      padding-left: 0;
      padding-top: 5px;
    }
    &.boundless {
      width: 120px;
      margin-top: 12px;
      padding-left: 0;
    }
    &.unidays {
      width: 100px;
    }
  }
`;
